import { getMainStatusSteps, getExpertOrderSteps } from "@/api/order";
import { ProgressBarByStep } from "@/components/ProgressBar";

interface Props {
  step: number;
  type?: string;
  /** 达人订单专用：是否使用达人6步流程 */
  isExpert?: boolean;
}

export default function ProgressDots({ step, type, isExpert }: Props) {
  const steps = isExpert
    ? getExpertOrderSteps()
    : getMainStatusSteps(type);

  return (
    <div className="mt-3">
      <ProgressBarByStep
        step={step}
        titles={steps}
        theme="orange"
        size="small"
      />
    </div>
  );
}
